// extracted by mini-css-extract-plugin
export default {"wrapper":"ListPage_wrapper__XeV3P","flexWrapper":"ListPage_flexWrapper__kkNR4","notFoundText":"ListPage_notFoundText__9HFaX"};